var accordionBlock = {
    $accordionBlock: $('.accordion-block:not(.no-collapse)'),

    init: function() {
        var _this = this;

        if (!_this.$accordionBlock.length) {
            return;
        }

        _this.$accordionRow = _this.$accordionBlock.find('.accordion-row');
        _this.$accordionRowTitle = _this.$accordionRow.find('.accordion-title');

        _this.accordionContentSelector = '.accordion-content';
        _this.$accordionContent = _this.$accordionRow.find(_this.accordionContentSelector);

        _this.$accordionContent.hide();

        _this.listener();
    },

    listener: function() {
        var _this = this;

        _this.$accordionRowTitle.click(function() {
            _this.onTitleClick($(this));
        });
    },

    onTitleClick: function($title) {
        var _this = this,
            $accordionBlock = $title.closest('.accordion-block');

        $title.toggleClass('special');

        $accordionBlock.trigger('accordionBlock:slideStart');
        $title.siblings(_this.accordionContentSelector).slideToggle(200, function() {
            $accordionBlock.trigger('accordionBlock:slideEnd');
        });
    }
};
